import { EVIDENCE_POINTS } from '@/config/marketingContent';

export default function EvidenceLayer() {
  return (
    <section id="evidence" className="py-16 md:py-20 border-t border-[#2a2a2a]">
      <div className="max-w-6xl mx-auto px-4">
        <p className="ni-label mb-3">Evidence layer</p>
        <h2 className="text-2xl md:text-3xl font-sans font-bold text-white mb-10">
          Methodology you can defend in the room
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          {EVIDENCE_POINTS.map((point) => (
            <div key={point.title} className="ni-panel p-5">
              <h3 className="text-sm font-mono uppercase tracking-wider text-index-accent mb-2">
                {point.title}
              </h3>
              <p className="text-sm text-white/55 font-sans leading-relaxed">{point.body}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
